/**
 * Logic for TypeFilter component
 */
(function(jQuery) {
    'use strict';

    function ProjectsAbroadSnippets() {
        var snippetsHelper = require('./snippets-helper');

        var global = {
            activeCategory: undefined,
        };

        var fn = {
            init: function() {
                fn.initGlobalListeners();
                fn.initListeners(
                    '.productSnippets',
                    '#product-snippets',
                    '/product-snippets/'
                );
                fn.initListeners(
                    '.reviewSnippets',
                    '#review-snippets',
                    '/review-snippets/'
                );

                snippetsHelper.updateCounters();
                snippetsHelper.checkedChildrenEnabled();
            },

            initGlobalListeners: function() {
                jQuery('.FilterBar__select--all').on('change', function() {
                    var checked = jQuery(this).prop('checked'),
                        value = jQuery(this).val(),
                        disabled = checked ? ':not(:disabled)' : '',
                        dataFilterParent =
                            '[data-filter-parent="' + value + '"]';

                    jQuery(
                        '.FilterBar__select:not(.FilterBar__select--all)' +
                            disabled +
                            dataFilterParent
                    ).prop('checked', checked);
                    // Reset pagination
                    jQuery('.page-ps').val(1);
                    jQuery('.offset-ps').val(0);
                    snippetsHelper.updateCounters();
                });

                jQuery('.FilterBar__select:not(.FilterBar__select--all)').on(
                    'change',
                    function() {
                        // Reset pagination
                        jQuery('.page-ps').val(1);
                        jQuery('.offset-ps').val(0);
                        snippetsHelper.updateCounters();
                    }
                );

                jQuery('.FilterBar--Category .FilterBar__select').on(
                    'change',
                    function() {
                        var category = jQuery(this).parents(
                            '.FilterBar__category'
                        );
                        if (
                            category.find('.FilterBar__select:checked')
                                .length === 0
                        ) {
                            global.activeCategory = undefined; // If the active category has no options selected, unset it as the active category
                        } else if (!global.activeCategory) {
                            global.activeCategory = category;
                        } else {
                            // do nothing, only change the active category if there wasn't one previously, or if all tickboxes in the active category have been unchecked.
                        }
                    }
                );

                jQuery('.has-subnav')
                    .children('a')
                    .on('click', snippetsHelper.openProductsFilter);

                var filterBarOverlay = jQuery('.FilterBar-overlay');
                //close lateral menu on mobile
                filterBarOverlay.on('swiperight', function() {
                    if (jQuery('.FilterBar').hasClass('bar-is-visible')) {
                        snippetsHelper.closeBar();
                        filterBarOverlay.removeClass('is-visible');
                    }
                });

                jQuery('.nav-on-left .FilterBar-overlay').on(
                    'swipeleft',
                    function() {
                        if (jQuery('.FilterBar').hasClass('bar-is-visible')) {
                            snippetsHelper.closeBar();
                            filterBarOverlay.removeClass('is-visible');
                        }
                    }
                );

                jQuery(
                    '.FilterBar-overlay, .FilterBar__close, .FilterBar__actions--see, .FilterBar__actions--done'
                ).on('click', function() {
                    snippetsHelper.closeBar();
                    window.pa.megamenu.toggleSearch('close');
                    filterBarOverlay.removeClass('is-visible');
                });

                jQuery('.FilterBar-sort').on('change', function() {
                    snippetsHelper.closeBar();
                    window.pa.megamenu.toggleSearch('close');
                    filterBarOverlay.removeClass('is-visible');
                    jQuery('.offset-ps').val(0);
                    jQuery('.FilterSortBy__option').removeClass('selected');
                    jQuery(this)
                        .parent('.FilterSortBy__option')
                        .addClass('selected');
                });
                //prevent default clicking on direct children of .FilterBar
                jQuery('.FilterBar')
                    .children('.has-subnav')
                    .children('a')
                    .on('click', function(event) {
                        event.preventDefault();
                    });

                jQuery('.expand').click(function() {
                    var clicked = jQuery(this);
                    var expand = clicked
                        .parent('.FilterBar-Heading li')
                        .children('.expandable');
                    expand.slideToggle(500, function() {
                        clicked.html(function() {
                            var expandContent = clicked.attr(
                                'data-expand-content'
                            );
                            var hideContent = clicked.attr('data-hide-content');
                            //change text based on condition
                            return expand.is(':visible')
                                ? hideContent
                                : expandContent;
                        });
                    });
                });

                if (
                    jQuery(
                        '.FilterBar-nav--type-of-works .Filter-Category__option'
                    ).length == 1
                ) {
                    // expand.show() won't work on page load, so wait until the filter is actually opened
                    jQuery('.FilterBar__dropdown-trigger--type-of-work').one(
                        'click',
                        function() {
                            var clicked = jQuery(
                                '.FilterBar-nav--type-of-works .Filter-Category__option .expand'
                            );
                            clicked
                                .parent('.FilterBar-Heading li')
                                .children('.expandable')
                                .show();
                            clicked.html(clicked.attr('data-hide-content'));
                        }
                    );
                }
            },

            initListeners: function(filterSelector, snippetsSelector, ajaxUrl) {
                var filterSnippets = jQuery(filterSelector);
                var snippets = jQuery(snippetsSelector);

                // Don't continue load anything if not on a page with filter snippets on it
                if (filterSnippets.length === 0) {
                    return;
                }

                filterSnippets
                    .find('.loadMoreSnippets')
                    .on('click', function(e) {
                        e.preventDefault();
                        var loadMoreSnippetsButton = jQuery(this);
                        loadMoreSnippetsButton.addClass('loading');

                        var recordsPerPage = jQuery('.rpp-ps').val();
                        var displayedSnippetCount = snippets.find(
                            '.TypeFilter__item'
                        ).length;
                        if (displayedSnippetCount < recordsPerPage) {
                            // Page 0
                            jQuery('#snippets-filters .page-ps').val(1);
                        } else {
                            jQuery('#snippets-filters .page-ps').val(
                                fn.getPageNumber() + 1
                            );
                        }

                        var filters = fn.getFilters(filterSnippets);
                        fn.filterReplace(
                            filterSnippets,
                            snippets,
                            ajaxUrl,
                            filters,
                            true,
                            function() {
                                loadMoreSnippetsButton.removeClass('loading');
                            }
                        );
                    });

                filterSnippets
                    .find('.FilterBar__clear-all, .FilterBar__clear-all-link')
                    .on('click', function() {
                        var checkboxes;
                        var closeFilter = false;

                        if (jQuery(this).hasClass('FilterBar__clear-all--cat')) {
                            checkboxes = jQuery(this)
                                .parents('.FilterBar-nav')
                                .find(
                                    '.FilterBar__select:checked:not(.FilterBar__select--all)'
                                );
                        } else {
                            checkboxes = jQuery(
                                '.FilterBar__select:checked:not(.FilterBar__select--all)'
                            );
                            closeFilter = true;
                        }

                        if (global.activeCategory) {
                            global.activeCategory = undefined;
                        }

                        if (closeFilter) {
                            snippetsHelper.closeBar();
                        }

                        checkboxes.prop('checked', false);
                        // get snippets only if something is being selected in the filters
                        if (checkboxes.length) {
                            fn.getNewSnippets(filterSnippets, snippets, ajaxUrl);
                        }

                        if (window.history) {
                            window.history.pushState(
                                {},
                                '',
                                window.location.pathname
                            );
                        }
                    });

                filterSnippets.find('.FilterBar__back').on('click', function() {
                    jQuery(this)
                        .closest('ul.FilterBar-nav')
                        .addClass('is-hidden');
                    fn.getNewSnippets(filterSnippets, snippets, ajaxUrl);
                });

                filterSnippets
                    .find('.FilterBar__header, .FilterBar__footer')
                    .on('click', function(e) {
                        e.stopImmediatePropagation();
                    });

                filterSnippets
                    .find('.FilterBar-trigger')
                    .on('click', snippetsHelper.showFilters);

                filterSnippets
                    .find('.FilterBar__close, .FilterBar__actions--see, .FilterBar__actions--done')
                    .on('click', function() {
                        fn.getNewSnippets(filterSnippets, snippets, ajaxUrl);
                    });

                filterSnippets.find('.FilterBar-sort').on('change', function() {
                    fn.getNewSnippets(filterSnippets, snippets, ajaxUrl);
                });

                // Check if the page was navigated to from pressing the back or forwards button
                // and if it was, load the filters that were selected before
                // Set a value to 0 on a hidden input, and after the visited check set it to 1,
                // the value of the input will be cached in most browsers so will be 1 when navigating back
                // also check if any filters have been selected or if the snippets are further than the first page, to avoid a needles ajax call if they are not
                var visited = jQuery('#page-visited');
                if (
                    visited.val() == 1 ||
                    jQuery(
                        '.FilterBar__select:checked:not(.FilterBar__select--all)'
                    ).length > 0 ||
                    fn.getPageNumber() > 1
                ) {
                    // Reset pagination
                    jQuery('.offset-ps').val(0);

                    var filters = fn.getFilters(filterSnippets);

                    // Clear original snippets
                    snippets.html('');
                    // Get pages snippets until the last page viewed is rendered
                    // filterReplace() will do a async ajax call, but we don't need to wait for this
                    // as we only just want to call it a certain number of times
                    for (
                        var pageToGet = 1;
                        pageToGet <= fn.getPageNumber();
                        pageToGet++
                    ) {
                        filters['page-ps'] = pageToGet;
                        fn.filterReplace(
                            filterSnippets,
                            snippets,
                            ajaxUrl,
                            filters,
                            true
                        );
                    }
                }
                visited.val(1);

                if (window.history) {
                    window.addEventListener('popstate', function() {
                        var projects = fn.getParamFromUrl('projects');
                        var destinations = fn.getParamFromUrl('destinations');
                        var tripFormats = fn.getParamFromUrl('trip-formats');
                        var sortBy = fn.getParamFromUrl('sort-by');
                        var dates = fn.getParamFromUrl('dates', false);

                        var filters = []
                            .concat(
                                projects,
                                destinations,
                                tripFormats,
                                sortBy,
                                dates
                            )
                            .filter(function(el) {
                                return el != null;
                            });

                        jQuery('.FilterBar__select').each(function() {
                            var checkbox = jQuery(this);

                            checkbox.prop(
                                'checked',
                                filters.indexOf(checkbox.attr('id')) !== -1
                            );
                        });

                        snippetsHelper.updateCounters();

                        var filters = fn.getFilters(filterSnippets);

                        fn.filterReplace(
                            filterSnippets,
                            snippets,
                            ajaxUrl,
                            filters,
                            false
                        );
                    });
                }
            },

            getPageNumber: function() {
                var pageNumber = jQuery('#snippets-filters .page-ps').val();
                pageNumber = parseInt(pageNumber, 10);
                return pageNumber;
            },

            filterReplace: function(
                filterSnippets,
                snippets,
                ajaxUrl,
                filters,
                append,
                callback
            ) {
                var pageNumber = fn.getPageNumber();

                jQuery.get(
                    ajaxUrl,
                    filters,
                    function(data) {
                        if (append) {
                            snippets.append(data.html);
                        } else {
                            snippets.html(data.html);
                        }

                        if (data.html.trim()) {
                            jQuery('#snippets-filters .page-ps').val(
                                pageNumber
                            );
                        }

                        if (!data.hasNextPage) {
                            filterSnippets.find('.loadMoreSnippets').hide();
                        } else {
                            filterSnippets.find('.loadMoreSnippets').show();
                        }

                        var recordsPerPage = parseInt(
                            jQuery('#snippets-filters .rpp-ps').val(),
                            10
                        );

                        var offsetStr = jQuery(
                            '#snippets-filters .offset-ps'
                        ).val();
                        offsetStr = offsetStr ? offsetStr : 0;
                        var offset = parseInt(offsetStr, 10);

                        var endNum = data.hasNextPage
                            ? offset + pageNumber * recordsPerPage
                            : data.total;

                        jQuery('.js-snippets-count-end').text(endNum);
                        jQuery('.js-snippets-count-total').text(data.total);

                        if (data.availableOptions) {
                            var availableOptions = data.availableOptions.map(
                                function(value) {
                                    return value.toString();
                                }
                            );

                            var options = jQuery('.FilterBar__select').not(
                                '.FilterBar__select--all'
                            );

                            for (var i = 0; i < options.length; i++) {
                                var option = jQuery(options[i]);
                                // Check if option is a descendant element of active category or not
                                if (
                                    (global.activeCategory &&
                                        !jQuery.contains(
                                            global.activeCategory[0],
                                            option[0]
                                        )) ||
                                    !global.activeCategory
                                ) {
                                    var value = option.val();
                                    option.prop(
                                        'disabled',
                                        availableOptions.indexOf(value) < 0
                                    );
                                } else if (
                                    global.activeCategory &&
                                    jQuery.contains(
                                        global.activeCategory[0],
                                        option[0]
                                    )
                                ) {
                                    option.prop('disabled', false);
                                }
                            }
                        }

                        snippetsHelper.checkedChildrenEnabled();
                        snippetsHelper.updateCounters();

                        if (callback) {
                            callback();
                        }
                    },
                    'json'
                );
            },

            setFilters: function(filterSnippets, filters) {
                var selectDestinations = filterSnippets.find(
                    '.FilterBar__select--destination:not(:disabled)'
                );
                var selectTripFormats = filterSnippets.find(
                    '.FilterBar__select--trip-formats:not(:disabled)'
                );
                var selectTypeOfWorkTags = filterSnippets.find(
                    '.FilterBar__select--tow:not(:disabled)'
                );
                var selectDates = filterSnippets.find(
                    '.FilterBar__select--dates:not(:disabled)'
                );
                var selectAgeGroups = filterSnippets.find(
                    '.FilterBar__select--age-groups:not(:disabled)'
                );
                var selectSortBy = filterSnippets.find(
                    '.FilterBar-sort:not(:disabled)'
                );

                var setFilterOption = function(filterName) {
                    return function() {
                        if (filterName in filters) {
                            var elem = jQuery(this);
                            elem.checked =
                                filters[filterName].indexOf(elem.val()) !== -1;
                        }
                    };
                };

                selectDestinations.each(setFilterOption('destinations-ps'));
                selectTripFormats.each(setFilterOption('trip-formats-ps'));
                selectTypeOfWorkTags.each(
                    setFilterOption('type-of-work-tags-ps')
                );
                selectDates.each(setFilterOption('dates-ps'));
                selectAgeGroups.each(setFilterOption('age-groups-ps'));
                selectSortBy.each(setFilterOption('sort-by-ps'));
            },

            getFilters: function(filterSnippets) {
                var getFilters = function(filterBarSelectSelector) {
                    var filterStr = '';
                    var inputs = filterSnippets.find(
                        filterBarSelectSelector + ':checked'
                    );
                    if (inputs.length > 0) {
                        inputs.each(function(i, elem) {
                            filterStr += jQuery(elem).val() + ',';
                        });
                        if (filterStr.trim() !== '') {
                            filterStr = filterStr.substr(
                                0,
                                filterStr.length - 1
                            );
                        }
                    }

                    return filterStr;
                };

                var filters = {
                    'page-ps': fn.getPageNumber(),
                    'rpp-ps': parseInt(
                        jQuery('#snippets-filters .rpp-ps').val(),
                        10
                    ),
                    'offset-ps': parseInt(
                        jQuery('#snippets-filters .offset-ps').val(),
                        10
                    ),
                    'siteId-ps': parseInt(
                        jQuery('#snippets-filters .siteId-ps').val(),
                        10
                    ),
                    'pageId-ps': parseInt(
                        jQuery('#snippets-filters .pageId-ps').val(),
                        10
                    ),
                    'destinations-ps': getFilters(
                        '.FilterBar__select--destination'
                    ),
                    'trip-formats-ps': getFilters(
                        '.FilterBar__select--trip-formats'
                    ),
                    'type-of-work-tags-ps': getFilters(
                        '.FilterBar__select--tow'
                    ),
                    'dates-ps': getFilters('.FilterBar__select--dates'),
                    'age-groups-ps': getFilters(
                        '.FilterBar__select--age-groups'
                    ),
                    'sort-by-ps': filterSnippets
                        .find('.FilterBar-sort:checked')
                        .val(),

                    'restrict-destinations-ps': jQuery(
                        '#snippets-filters .restrictDestinationsIds-ps'
                    ).val(),
                    'restrict-trip-formats-ps': jQuery(
                        '#snippets-filters .restrictTripFormatIds-ps'
                    ).val(),
                    'restrict-type-of-works-ps': jQuery(
                        '#snippets-filters .restrictTypeOfWorksIds-ps'
                    ).val(),
                };

                return filters;
            },

            getParamFromUrl: function(paramName, convertToName) {
                var url = new URL(window.location.href);
                var val = url.searchParams.getAll(paramName);

                if (val.length === 0) {
                    val = url.searchParams.getAll(paramName + '[]');
                }

                if (val.length === 1 && typeof val[0] === 'string') {
                    val = val[0].split(',');
                }

                if (convertToName !== false) {
                    val = val.map(function(v) {
                        return jQuery(
                            '.FilterBar__content label:contains("' + v + '")'
                        ).attr('for');
                    });
                }

                if (val.length === 1) {
                    val = val[0];
                }

                return val;
            },

            replaceFilterStringIdsWithNames: function(filterstr) {
                return filterstr
                    .split(',')
                    .map(function(filter) {
                        return jQuery('label[for="' + filter + '"]').text();
                    })
                    .join(',');
            },

            setFiltersUrl: function (filters, jQfilterSnippets) {
                var paramObj = {};

                var filteredTypeOfWorks = jQuery(
                    '.filteredTypeOfWorksIds-ps'
                ).val();

                const nonRestrictedTowtIds = filters['type-of-work-tags-ps']
                    .replace(filteredTypeOfWorks, '')
                    .split(',');

                const towtNames = nonRestrictedTowtIds.map(towtId => {
                    const towtElem = jQuery('label[for="' + towtId + '"]');
                    const name = towtElem.text();

                    const isCollision = name && (jQuery(`label:contains('${name}')`).length > 1);

                    if (isCollision) {
                        const parentTowName = towtElem.parents('.Filter-Category__option')
                        .first()
                        .find('.FilterBar__select-container > .FilterBar--Name')
                        .text();

                        return parentTowName + '_' + name;
                    }

                    return name;
                });

                if (towtNames) {
                    paramObj['projects'] = towtNames.join(',');
                }

                var filteredDestinations = jQuery(
                    '.filteredDestinationsIds-ps'
                ).val();
                var destinations = filters['destinations-ps'].replace(
                    filteredDestinations,
                    ''
                );
                if (destinations) {
                    paramObj[
                        'destinations'
                    ] = fn.replaceFilterStringIdsWithNames(destinations);
                }

                var filteredTripFormats = jQuery(
                    '.filteredTripFormatIds-ps'
                ).val();
                var tripFormats = filters['trip-formats-ps'].replace(
                    filteredTripFormats,
                    ''
                );
                if (tripFormats) {
                    paramObj[
                        'trip-formats'
                    ] = fn.replaceFilterStringIdsWithNames(tripFormats);
                }

                var filteredDates = jQuery('.filteredDates-ps').val();
                var dates = filters['dates-ps'].replace(filteredDates, '');
                if (dates) {
                    paramObj['dates'] = dates;
                }

                if (filters['age-groups-ps']) {
                    paramObj['age-groups'] = filters['age-groups-ps'];
                }

                if (filters['sort-by-ps']) {
                    paramObj['sort-by'] = filters['sort-by-ps'];
                }

                var params = jQuery.param(paramObj);

                if (window.history) {
                    window.history.pushState(
                        {},
                        '',
                        window.location.pathname + (params ? '?' + params : '')
                    );
                }
            },

            getNewSnippets: function(
                jQfilterSnippets,
                snippets,
                ajaxUrl,
                updateUrl
            ) {
                snippetsHelper.updateCounters();

                // Get new snippets for new search filters, so reset page back to first
                jQuery('#snippets-filters .page-ps').val(1);

                var filters = fn.getFilters(jQfilterSnippets);

                fn.setFiltersUrl(filters, jQfilterSnippets);

                fn.filterReplace(
                    jQfilterSnippets,
                    snippets,
                    ajaxUrl,
                    filters,
                    false
                );
            },
        };

        jQuery(fn.init);
    }

    new ProjectsAbroadSnippets();
})(jQuery);
